import { render } from "./ProfileCard.vue?vue&type=template&id=625e03fe&scoped=true"
import script from "./ProfileCard.vue?vue&type=script&lang=js"
export * from "./ProfileCard.vue?vue&type=script&lang=js"

import "./ProfileCard.vue?vue&type=style&index=0&id=625e03fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-625e03fe"]])

export default __exports__